// src/redux/slices/EmployeeLetterSlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = 'http://213.210.37.235:3000/api';

// 🔄 Async thunk to fetch employee letters
export const fetchEmployeeLetters = createAsyncThunk(
  'employeeLetter/fetchEmployeeLetters',
  async () => {
    const response = await axios.get(`${BASE_URL}/employee-letters`);
    return response.data;
  }
);

const employeeLetterSlice = createSlice({
  name: 'employeeLetter',
  initialState: {
    employeeLetters: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeLetters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeLetters.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeLetters = action.payload;
      })
      .addCase(fetchEmployeeLetters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default employeeLetterSlice.reducer;
